module.exports = __webpack_public_path__ + "static/media/ZEINAB ALHAWRAA ALABBO.4b31d130.png";